import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "No 600-mile Seattle drive — we handle agency submission",
      "Ideal for state government officials on official travel",
      "Perfect for Carroll College students studying abroad",
      "Great for Montana outdoor recreation industry international staff",
      "Helena Regional Airport (HLN) flyers connecting through SEA/DEN/SLC",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no Seattle drive required",
      "Faster than self-service at Helena post office",
      "Good for planned international trips from HLN",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Helena USPS is primary acceptance facility",
      "No document review — errors cause rejection and restart",
      "In-person clerk appointment required at Lewis and Clark County facilities",
      "Montana mail routing through Great Falls adds extra transit days",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "No passport agency in Montana — closest is Seattle, ~600 miles via I-90",
      "8.5+ hour drive to Seattle Passport Agency",
      "NPIC appointment required — no walk-ins at Seattle agency",
      "Life-or-death emergencies only with documentation",
      "Montana winter conditions make driving to Seattle hazardous Nov–Mar",
      "Air travel from HLN to SEA adds $300+ on top of agency fees",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Helena"
      headingExtra="MT"
      introText="Helena travelers — state legislators and government staff on official travel, Carroll College students preparing for study abroad, outdoor recreation industry professionals with international assignments, and HLN flyers — have several options for getting a passport fast. Here is how they compare, and why most Montanans choose a U.S. Department of State registered passport courier rather than attempting the 600-mile journey to Seattle."
      options={options}
      emergencyDescription="Montana has zero passport agencies. The closest is in Seattle — approximately 600 miles, 8.5+ hours via I-90. Winter conditions make this route treacherous November through March. Even flying from HLN to SEA adds $300+ round-trip before agency fees. NPIC appointment is mandatory."
      disclaimerText="*Processing speed depends on eligibility and documentation. Montana has no passport agency — the closest is Seattle, WA (~600 miles). Not all applicants qualify for Regional Agency Processing."
    />
  );
}